import $ from "jquery";
import Sdgs from "../../apis/SDGs";
import User from "../../apis/User";
import sdgs from "../../const/control_panel/sdgs";


export const getAllSdgs = ({ commit, dispatch, rootState }, { pageParam, type }) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    var allSdgs;

    return Sdgs.list(pageParam, rootState.sdgs.searchQuery).then(async response => {

        if (response != '') {

            allSdgs = response.data.data;

            for (const sdgs of allSdgs) {

                if (sdgs.target_ids != null) {

                    sdgs.target_user = [];

                    for (const targetId of sdgs.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await sdgs.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_SDGS', allSdgs);

            commit('SET_PAGINATION', response.data);

            console.log(response.data);
            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }


    }).catch((error) => {
    }).finally(() => {
        dispatch('common/setSpinnerStatus', false, { root: true })

    });

}

export const viewSdgs = ({ commit, dispatch, rootState }, id) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    return Sdgs.show(id).then(async response => {

        
        var sdgs = response.data.data;

        if (sdgs.target_ids != null) {

            sdgs.target_user = [];

            for (const targetId of sdgs.target_ids) {


                await User.show(targetId).then(async response => {

                    if (response != '') {

                        await sdgs.target_user.push(response.data.data);

                    }

                });

            }

        }

        commit('SET_SDGS',sdgs);


    })

        .catch(() => { })

        .finally(() => {
            dispatch('common/setSpinnerStatus', false, { root: true })
        });
}

export const deleteSdgs = ({ commit, dispatch, rootState }, id) => {

    dispatch('common/setSpinnerStatus', true, { root: true });


    return Sdgs.delete(id).then(

        (response) => {

            if (response != '') {

                commit('DELETE_SDGS', id);

                $(".bulktool").removeClass("open");

                $(".command_wrap_inbox").removeClass("hide");

                $(".modal").removeClass("open");


                return dispatch('common/setSucccessMessageStatus', {

                    status: true,
                    message: "SDG が正常に削除されました。",

                }, { root: true });

            }
        },

        (error) => {

            console.log(error);
        }
    )

        .catch(() => { })

        .finally(() => {

            return dispatch('common/setSpinnerStatus', false, { root: true });

        });
}

export const setDeleteId = ({ commit, dispatch, rootState }, id) => {

    commit('SET_DELETE_SDGS_ID', id);

}

export const setFileterStatus = ({ commit, dispatch, rootState }, { papeParam, status }) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    let searchStatus = "";

    if (status != "")

        searchStatus = "&where=status@" + `${status}`;

    commit('SET_SEARCH_QUERY', searchStatus);

    return Sdgs.filter(papeParam, searchStatus).then(async response => {

        var allSdgs;

        if (response != '') {

            allSdgs = response.data.data;

            for (const sdgs of allSdgs) {

                if (sdgs.target_ids != null) {

                    sdgs.target_user = [];

                    for (const targetId of sdgs.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await sdgs.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_SDGS', allSdgs);

            commit('SET_PAGINATION', response.data);

            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }


    })
        .catch(() => { })

        .finally(() => {

            setTimeout(() => {

                dispatch('common/setSpinnerStatus', false, { root: true })

            }, 10000);
        });

}

export const getSearchData = ({ commit, dispatch, rootState }, { papeParam, searchTerms }) => {


    dispatch('common/setSpinnerStatus', true, { root: true })

    let statusQuery = "&where=status@" + `${searchTerms.status}`;

    let dateQuery = "";

    if (searchTerms.published_start != "") {

        dateQuery = "&datetime=created_at@gte," + `${searchTerms.published_start}T00:00:00`;

    }

    if (searchTerms.published_end != "") {

        dateQuery = "&datetime=created_at@lte," + `${searchTerms.published_end}T23:59:59`;

    }

    if (searchTerms.published_end != "" && searchTerms.published_start != "") {

        dateQuery = "&datetime=created_at@between," + `${searchTerms.published_start}T00:00:00/` + `${searchTerms.published_end}T23:59:59`;

    }

    commit('SET_SEARCH_QUERY', statusQuery + dateQuery);


    return Sdgs.search(papeParam, statusQuery + dateQuery).then(async response => {


        var allSdgs;

        if (response != '') {

            allSdgs = response.data.data;

            for (const sdgs of allSdgs) {

                if (sdgs.target_ids != null) {

                    sdgs.target_user = [];

                    for (const targetId of sdgs.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await sdgs.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_SDGS', allSdgs);

            commit('SET_PAGINATION', response.data);

            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }


    })
        .catch(() => { })

        .finally(() => {

            dispatch('common/setSpinnerStatus', false, { root: true })

        });

}

export const inputSearchData = ({ commit, dispatch, rootState }, { pageParam, searchTerms }) => {

    dispatch('common/setSpinnerStatus', true, { root: true })

    commit('SET_SEARCH_QUERY', "&keyword=title@" + `${searchTerms}`);

    return Sdgs.inpuSearch(pageParam, searchTerms).then(async response => {

        var allSdgs;

        if (response != '') {

            allSdgs = response.data.data;

            for (const sdgs of allSdgs) {

                if (sdgs.target_ids != null) {

                    sdgs.target_user = [];

                    for (const targetId of sdgs.target_ids) {


                        await User.show(targetId).then(async response => {

                            if (response != '') {

                                await sdgs.target_user.push(response.data.data);

                            }

                        });

                    }

                }


            }


            commit('SET_ALL_SDGS', allSdgs);

            commit('SET_PAGINATION', response.data);

            dispatch('common/setSpinnerStatus', false, { root: true })

            rootState.common.pagination = response.data;

        }

    })
        .catch(() => { })

        .finally(() => {
            dispatch('common/setSpinnerStatus', false, { root: true })

        });

}

